import { useEffect, useState } from "react"

import { Box, Img, TextWithIcon } from "ui-kit/components-branded/index"
import { Icon } from "components"
import { PaymentMethod } from "modules/ClientAccount/utils"
import { AttachCard } from "modules/ClientAccount/components/AttachCard"
import { CardItem } from "modules/ClientAccount/components/PaymentMethodWithCard/CardItem"
import style from "modules/ClientAccount/components/PaymentMethodWithCard/style.module.scss"
import { AutoPaymentText } from "modules/ClientAccount/components/AutoPaymentText"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
interface Props {
    cards: PaymentMethod[]
    reFetchCardList: () => void
}

export function PaymentMethodWithCard({ cards, reFetchCardList }: Props) {
    const [{ userAccount: clientUserAccount }] = useClientContext()
    const isB2b = clientUserAccount.is_b2b
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

    useEffect(() => {
        !isModalOpen && reFetchCardList()
    }, [isModalOpen])

    return (
        <Box data-test-id="clientacc-payment-method-block">
            <div className={style.titleWrapper}>
                <TextWithIcon
                    icon={<Img className={style.creditCardEmoji} src="credit-card-emoji.png" />}
                    position="left"
                    isAccent
                    size="h3"
                    className={style.title}
                >
                    Мои карты
                </TextWithIcon>
            </div>
            <div className={style.cardList}>
                {cards.map((item) => (
                    <CardItem
                        card={item}
                        key={item.external_id}
                        reFetchCardList={reFetchCardList}
                    />
                ))}
            </div>
            <div className={style.addNewCardText} onClick={() => setIsModalOpen(true)}>
                <TextWithIcon
                    icon={<Icon type="plus-circle-outline" size="20" />}
                    position="left"
                    className={style.addNewCard}
                >
                    Привязать новую карту
                </TextWithIcon>
            </div>
            {!isB2b && <AutoPaymentText />}
            <AttachCard isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} cards={cards} />
        </Box>
    )
}
